import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { AnalyticsKPICards } from "./analytics/AnalyticsKPICards";
import { AnalyticsDailyChart, AnalyticsHourlyChart } from "./analytics/AnalyticsCharts";
import { AnalyticsCustomerTable } from "./analytics/AnalyticsCustomerTable";
import { SkeletonLoader, AnalyticsEmptyState } from "./analytics/AnalyticsStates";
import { useFetchAnalytics } from "./analytics/utils";

export function WhatsAppAnalyticsTab() {
  const { authAxios } = useAuth();
  const [period, setPeriod] = useState(30);
  const { data, loading, error } = useFetchAnalytics(authAxios, period);

  if (loading) return <SkeletonLoader />;
  if (error) return <AnalyticsEmptyState type="error" />;
  if (!data) return <AnalyticsEmptyState type="nodata" />;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          Análisis del rendimiento del chatbot WhatsApp.
        </p>
        <Select value={String(period)} onValueChange={(v) => setPeriod(Number(v))}>
          <SelectTrigger className="w-40" data-testid="analytics-period-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="7">Últimos 7 días</SelectItem>
            <SelectItem value="30">Últimos 30 días</SelectItem>
            <SelectItem value="90">Últimos 90 días</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <AnalyticsKPICards data={data} />

      <div className="grid md:grid-cols-2 gap-6">
        <AnalyticsDailyChart data={data.daily} />
        <AnalyticsHourlyChart data={data.hourly} insights={data.hourly_insights} />
      </div>

      <AnalyticsCustomerTable customers={data.top_customers} />
    </div>
  );
}
